module.exports = __webpack_public_path__ + "static/media/plan-blk.2becb07c.png";